import type { DeviceType } from './types';

export function parseUserAgent(ua: string): {
  device: DeviceType;
  browser: string;
  os: string;
} {
  const source = ua || '';
  const device: DeviceType = /iPad|Tablet/i.test(source)
    ? 'tablet'
    : /Mobile|Android|iPhone/i.test(source)
      ? 'mobile'
      : 'desktop';

  let browser = '其他';
  if (/MicroMessenger/i.test(source)) browser = '微信';
  else if (/baiduboxapp/i.test(source)) browser = '百度';
  else if (/QQ\//i.test(source)) browser = 'QQ';
  else if (/Edg\//i.test(source)) browser = 'Edge';
  else if (/OPR\/|Opera/i.test(source)) browser = 'Opera';
  else if (/Chrome\//i.test(source)) browser = 'Chrome';
  else if (/Firefox\//i.test(source)) browser = 'Firefox';
  else if (/Safari\//i.test(source)) browser = 'Safari';

  let os = '其他';
  if (/Windows/i.test(source)) os = 'Windows';
  else if (/Android/i.test(source)) os = 'Android';
  else if (/iPhone|iPad|iPod|iOS/i.test(source)) os = 'iOS';
  else if (/Mac OS X|Macintosh/i.test(source)) os = 'macOS';
  else if (/Linux/i.test(source)) os = 'Linux';

  return { device, browser, os };
}

export function deviceLabel(device: DeviceType): string {
  if (device === 'mobile') return '手机';
  if (device === 'tablet') return '平板';
  return '电脑';
}

export function deviceIcon(device: DeviceType): string {
  if (device === 'mobile') return 'ri-smartphone-line';
  if (device === 'tablet') return 'ri-tablet-line';
  return 'ri-computer-line';
}
